<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-8
        .u-mb-xs(v-for="item,idx in $t('sec1Items')")
          AppLink.button-link(:to="item.url") {{item.title}}

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-8
        .u-mb-xs(v-for="item,idx in $t('sec2Items')")
          AppLink.button-link(:to="item.url") {{item.title}}

  section.u-mt-md
    .grid
      .column.is-widescreen-4
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-8
        .u-mb-xs(v-for="item,idx in $t('sec3Items')")
          AppLink.button-link(:to="item.url") {{item.title}}



  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Reports",
    "pageDesc":"See our performance and contributions for a better world in numbers.",
    "mantra":"Our citizenship |reports.",
    "mantraDesc":"Baianat is working hard on making real impact that can be measured and sensed in every possible way. Adhering to our transparency value, we share our progress on a yearly basis.",
    "sec1":"People reports",
    "sec1Items":{
      "1":{
        "title":"Equality report",
        "url":"/"
      },
      "2":{
        "title":"Health report",
        "url":"/"
      },
      "3":{
        "title":"Poverty report",
        "url":"/"
      }
    },
    "sec2":"Environment reports",
    "sec2Items":{
      "1":{
        "title":"Ocean health report",
        "url":"/"
      },
      "2":{
        "title":"Forest health report",
        "url":"/"
      },
      "3":{
        "title":"Plastic deduction report",
        "url":"/"
      }
    },
    "sec3":"Communities reports",
    "sec3Items":{
      "1":{
        "title":"Disaster act report",
        "url":"/"
      },
      "2":{
        "title":"Non profit empowerment",
        "url":"/"
      }
    }
  },
  "ar": {
    "pageTitle":"التقارير",
    "pageDesc":"شاهد أدائنا ومساهماتنا من أجل عالم أفضل بالأرقام والتقارير التي تجعلك على وعى أكثر بكل ما نقوم به.",
    "mantra":"التقارير والتأثير |الذي نقوم به.",
    "mantraDesc":"تعمل بيانات جاهدة من أجل إحداث تأثير حقيقي يمكن قياسه بكل طريقة ممكنة. نتمسك بقيمة الشفافية لدينا، ولهذا نشارك تقدمنا سنويًا.",
    "sec1":"تقارير الأفراد",
    "sec1Items":{
      "1":{
        "title":"تقرير المساواة",
        "url":"/"
      },
      "2":{
        "title":"تقرير الصحة",
        "url":"/"
      },
      "3":{
        "title":"تقرير الفقر",
        "url":"/"
      }
    },
    "sec2":"تقارير البيئة",
    "sec2Items":{
      "1":{
        "title":"تقرير المحيط",
        "url":"/"
      },
      "2":{
        "title":"تقرير الغابات",
        "url":"/"
      },
      "3":{
        "title":"تقرير البلاستيك",
        "url":"/"
      }
    },
    "sec3":"تقارير المجتمعات",
    "sec3Items":{
      "1":{
        "title":"تقرير مناهضة الكوارث",
        "url":"/"
      },
      "2":{
        "title":"التمكين للمنظمات غير الربحية",
        "url":"/"
      }
    }
  }
}
</i18n>
